import { Button, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  checkExtFolders,
  checkExtRelatedListSettings,
  checkZohoAuth,
  generateAuthUrl,
  getZohoAuthUrl,
  getZUID,
  revokeZoho,
  setUpOrgVariable,
  verifyZohoAuthAndCreateRelatedListWidget,
} from "../../Components/API/ZohoAPICalling";
import {
  authCheckDuration,
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
  maxAuthCheck,
  snackDetails,
} from "../../config/otherConstant";
import { ZUID_API_NAME } from "../../config/serviceConstant";
import RevokeDialog from "./RevokeDialog";
import {
  ZOHO_CREATE_SCOPES,
  ZOHO_DELETE_SCOPES,
  ZOHO_READ_SCOPES,
  ZOHO_SCOPES,
  ZOHO_SHARE_SCOPES,
  ZOHO_UPDATE_SCOPES,
  permissions,
} from "../../config/scope";

const ZOHO = window?.ZOHO;
let checkAuthCount;

function ZohoUserAuthentication({
  apiKey,
  orgId,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  zuid,
  setZuid,
  connName,
  user,
  currentUser,
  setSnack,
  userAuth,
  authenticatedUserMap,
  setAuthenticatedUserMap,
  defaultAuthenticator,
}) {
  const [authLoading, setAuthLoading] = useState(false);
  const [revokeLoading, setRevokeLoading] = useState(false);
  const [requestInvitation, setRequestInvitation] = useState(false);
  const [zohoAuth, setZohoAuth] = useState(userAuth);

  const [role, setRole] = useState(permissions?.[4]);

  const handleChange = (event) => {
    setRole(event.target?.value);
  };

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      fullaccess: false,
      read: true,
      write: false,
      update: false,
      delete: false,
      share: false,
    },
  });

  const zohoHeaders = {
    orgid: orgId,
    connname: connName,
    apikey: apiKey,
    datacenterurl: dataCenterUrl,
    dataCenter: dataCenter,
    zapikey: zApiKey,
  };

  const handleAuthenticate = async () => {
    setAuthLoading(true);
    const zohoAuthUrl = await getZohoAuthUrl(zohoHeaders);
    if (!zohoAuthUrl) {
      // Set snak error
      setAuthLoading((prev) => false);
      setSnack(getOpenSnakErrorData());
      return "Error";
    }

    checkAuthCount = 1;
    const myAuthCheckInterval = setInterval(async () => {
      const zohoStatus = await checkZohoAuth(zohoHeaders);
      const authCheckStatus = await handleAuthCheck();
      const { isAuthenticated, isRelatedListCreated } = authCheckStatus;

      if (isAuthenticated) {
        const workdriveZuid = await getZUID(zohoHeaders);
        const zuid = workdriveZuid?.data?.data;
        setUpOrgVariable(ZOHO, ZUID_API_NAME, zuid);
        checkExtFolders(zuid, zohoHeaders);
        checkExtRelatedListSettings(zohoHeaders);
        setSnack(getOpenSnakSuccessData());
        setZohoAuth((prev) => true);
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }

      if (checkAuthCount++ > maxAuthCheck) {
        setSnack(
          getOpenSnakErrorData(
            "Error!!! Please authenticate and refresh the page.",
            10 * 1000
          )
        );
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }
    }, authCheckDuration);

    const newwindow = window.open(
      zohoAuthUrl,
      "windowName",
      "height=640,width=1024"
    );

    if (window.focus) {
      newwindow.focus();
    }
  };

  const handleAuthCheck = async () => {
    try {
      const zohoAuthResp = await verifyZohoAuthAndCreateRelatedListWidget(
        zohoHeaders
      );
      return zohoAuthResp;
    } catch (error) {
      return false;
    }
  };

  const handleRevoke = async () => {
    setRevokeLoading((prev) => true);
    const revokeResp = await revokeZoho(zohoHeaders);
    const authCheckStatus = await checkZohoAuth(zohoHeaders);
    delete authenticatedUserMap[user?.email];
    setAuthenticatedUserMap((prev) => authenticatedUserMap);
    setZohoAuth((prev) => authCheckStatus);
    setSnack(getOpenSnakSuccessData());
    setRevokeLoading((prev) => false);
  };

  const checkAuth = async (cb) => {
    const zohoStatus = await checkZohoAuth(zohoHeaders);
    cb(zohoStatus);
  };

  const testifyAuth = async (cb) => {
    checkAuth((zohoStatus) => {
      console.log({ zohoStatus });
      if (!zohoStatus) {
        handleRevoke();
      }
    });
    const zohoStatus = await checkZohoAuth(zohoHeaders);
    cb(zohoStatus);
  };

  const onSubmit = async (data) => {
    setAuthLoading(true);
    // let scopes = ZOHO_READ_SCOPES;
    // if (data?.create) {
    //   scopes = [...scopes, ...ZOHO_CREATE_SCOPES];
    // }
    // if (data?.update) {
    //   scopes = [...scopes, ...ZOHO_UPDATE_SCOPES];
    // }
    // if (data?.delete) {
    //   scopes = [...scopes, ...ZOHO_DELETE_SCOPES];
    // }
    // if (data?.share) {
    //   scopes = [...scopes, ...ZOHO_SHARE_SCOPES];
    // }
    // if (data?.fullaccess) {
    //   scopes = ZOHO_SCOPES;
    // }
    const zohoAuthUrl = await generateAuthUrl(zohoHeaders, role);
    if (!zohoAuthUrl) {
      // Set snak error
      setAuthLoading((prev) => false);
      setSnack(getOpenSnakErrorData());
      return "Error";
    }

    try {
      // + ",raihan@instawebworks.com.au"
      // https://www.zohoapis.com/crm/v2/functions/easyworkdriveforcrm__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=<zapikey>
      let func_name = "easyworkdriveforcrm__send_invitation_mail";
      var req_data = {
        email: user?.email,
        url: zohoAuthUrl,
        invitor: currentUser?.full_name,
        invitor_email: currentUser?.email,
      };
      const invitationResp = await ZOHO.CRM.FUNCTIONS.execute(
        func_name,
        req_data
      );

      setSnack(
        getOpenSnakSuccessData("Success!! Mail has been sent successfully")
      );
    } catch (error) {
      setSnack(getOpenSnakErrorData(error));
    }

    // send this url through deluge code
    setAuthLoading(false);
    setRequestInvitation((prev) => false);
  };

  const handleIntive = async () => {
    setRequestInvitation((prev) => true);

    // setAuthLoading(true);
    // const zohoAuthUrl = await generateAuthUrl(zohoHeaders);
    // if (!zohoAuthUrl) {
    //   // Set snak error
    //   setAuthLoading((prev) => false);
    //   setSnack(getOpenSnakErrorData());
    //   return "Error";
    // }

    // setAuthLoading(false);
  };

  const handleClose = () => {
    setRequestInvitation(false);
  };

  // useEffect(() => {
  //   if (orgId && apiKey && dataCenterUrl) {
  //     checkAuth((bool) => {
  //       setZohoAuth((prev) => bool);
  //       setAuthLoading((prev) => false);
  //     });
  //   }
  // }, []);

  if (authLoading) {
    return (
      <Button disabled variant="outlined" size="small">
        Authenticating...
      </Button>
    );
  }

  if (revokeLoading) {
    return (
      <Button disabled variant="outlined" size="small">
        Revoking...
      </Button>
    );
  }

  if (requestInvitation) {
    return (
      <>
        <Dialog
          open={requestInvitation}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="share-popup"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "400px", // Set your width here
                padding: "10px",
              },
            },
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: ".5rem", right: ".5rem" }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle id="alert-dialog-title" sx={{ pb: 0 }}>
            Set Role & Send Invitation
          </DialogTitle>
          <DialogTitle
            component="span"
            id="alert-dialog-title-sub"
            sx={{
              py: 0,
              fontWeight: "regular",
              fontSize: "14px",
              lineHeight: "26px",
              letterSpacing: "0.36px",
              color: "rgba(0,0,0,.6)",
            }}
          >
            Assign a role to the selected user before sending the invitation.
          </DialogTitle>

          <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ my: "1rem" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Role</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={permissions?.find(
                      (permissions) => permissions?.name === role?.name
                    )}
                    label="Role"
                    onChange={handleChange}
                  >
                    {permissions.map((permission) => (
                      <MenuItem value={permission}>{permission?.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Button type="submit" size="small" variant="contained">
                Send Invitation
              </Button>
              {/* <input type="submit" /> */}
            </form>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  if (!zohoAuth && user?.email != currentUser?.email) {
    return (
      <>
        {Object.keys(authenticatedUserMap)?.includes(defaultAuthenticator) ? (
          <Button onClick={handleIntive} variant="outlined" size="small">
            Invite
          </Button>
        ) : (
          <Button disabled>Invite</Button>
        )}
      </>
    );
  }

  if (
    !zohoAuth &&
    user?.email === currentUser?.email &&
    user?.email === defaultAuthenticator
  ) {
    return (
      <Button onClick={handleAuthenticate} variant="outlined" size="small">
        Authenticate Zoho
      </Button>
    );
  }

  if (zohoAuth) {
    return (
      // <Button onClick={handleRevoke} variant="outlined"  size="small">
      //   Revoke Zoho
      // </Button>

      <>
        <Button onClick={testifyAuth}>Verify</Button>
        <RevokeDialog service="zoho" handleRevokeService={handleRevoke} />
      </>
    );
  }

  return <></>;
}

export default ZohoUserAuthentication;
